import { IoMdCheckmarkCircleOutline, IoMdCloseCircleOutline } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
	setBillingType,
	setPlan,
} from "../../../store/reducers/subscriptionSlice/subscriptionSlice";

const PERIOD_LABELS = {
	monthly: "Month",
	quarterly: "Quarter",
	yearly: "Year",
	annual: "Year",
};

const PricingCard = ({
	plan,
	billing,
	billingDetails,
	changeType,
	currentPlanKey,
	onOpenFreeModal,
	onSelectPlan,
}) => {
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const isCurrentPlan = changeType === "Current Plan";
	const isUpgrade = changeType === "Upgrade Plan";
	const isDowngrade = changeType === "Downgrade Plan";

	const durationLabel =
		PERIOD_LABELS[billingDetails?.period?.toLowerCase()] ??
		billingDetails?.period;

	const buttonText = (() => {
		if (isCurrentPlan) return "Current Plan";

		switch (plan.key) {
			case "professional":
				return "Go Professional";

			case "enterprise":
				return "Go Enterprise";

			default:
				return "Get Started";
		}
	})();

	const handleClick = () => {
		if (isCurrentPlan) return;

		if (plan.key.includes("free")) {
			onOpenFreeModal?.(plan);
			return;
		}

		if (currentPlanKey && onSelectPlan) {
			onSelectPlan(
				plan,
				billingDetails,
				isDowngrade ? "downgrade" : "upgrade"
			);
			return;
		}

		dispatch(
			setPlan({
				id: plan._id,
				key: plan.key,
				title: plan.name,
				description: plan.meta.description,
				billing: plan.billing,
			})
		);

		dispatch(setBillingType(billing));

		navigate(
			`/checkout?plan=${plan.key}&billing=${billing}&step=billing-details`
		);
	};

	return (
		<div className={`pricing-card ${isCurrentPlan ? "current-plan" : ""}`}>
			{isCurrentPlan && <div className="current-badge">Current Plan</div>}
			{isUpgrade && <div className="current-badge">Upgrade Plan</div>}
			{isDowngrade && <div className="current-badge">Downgrade Plan</div>}

			<h5 className="title">{plan.name}</h5>

			<p className="desc">{plan.meta.description}</p>

			<div className="price">
				{plan.custom ? (
					<p className="contact">Contact Us</p>
				) : (
					<div className="price-main">
						<div className="price-row">
							<span className="currency">₹</span>

							<span className="amount">
								{Number(
									billingDetails?.amount_without_gst_in_rupees ?? 0
								).toFixed(2)}
							</span>
						</div>

						<div className="price-info">
							<span className="duration">/{durationLabel}</span>

							<span className="gst">
								+ GST ₹
								{Number(
									billingDetails?.tax_amount_in_rupees ?? 0
								).toFixed(2)}
							</span>
						</div>
					</div>
				)}
			</div>

			<div className="features-wrapper">
				<ul className="features">
					{plan.display_features?.map((item, index) => {
						const isObject =
							typeof item === "object" && item !== null;

						const label = isObject ? item.label : item;
						const display = isObject ? item.display : null;
						const available = isObject ? item.available : true;

						return (
							<li
								key={index}
								style={{ opacity: available ? 1 : 0.5 }}
							>
								{available ? (
									<IoMdCheckmarkCircleOutline
										className="icon"
										style={{ color: "#68C230" }}
									/>
								) : (
									<IoMdCloseCircleOutline
										className="icon"
										style={{ color: "#dc3545" }}
									/>
								)}

								<span>
									{display &&
										display !== "✓" &&
										display !== "✗"
										? `${display} ${label}`
										: label}
								</span>
							</li>
						);
					})}
				</ul>
			</div>

			<div className="btn-group-custom">
				<button
					onClick={handleClick}
					className={`btn mt-0 w-100 ${isCurrentPlan
						? "btn-disabled"
						: "btn-primary"
						}`}
					disabled={isCurrentPlan}
				>
					{buttonText}
				</button>

				<Link
					to="https://pharmnex-app.vercel.app/pricing"
					className="btn btn-primary w-100 mt-0"
				>
					Learn More
				</Link>
			</div>
		</div>
	);
};

export default PricingCard;